import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';

import { TooltipType } from './basis-overlay-tooltip.directive';

@Component({
  selector: 'prlw-table-basis-overlay-tooltip-ui',
  templateUrl: './basis-overlay-tooltip.component.html',
  styleUrls: ['./basis-overlay-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasisOverlayTooltipComponent implements AfterViewInit {
  @ViewChild('plantContainer') public plantContainer?: ElementRef;
  @Input() public name!: string;
  @Input() public plants!: string[];
  @Input() public type!: TooltipType;

  public ngAfterViewInit(): void {
    const elem = this.plantContainer?.nativeElement as HTMLElement | undefined;
    if (elem && elem.offsetWidth < elem.scrollWidth) {
      elem.style.width = `${elem.scrollWidth}px`;
    }
  }

  public isAll(): boolean {
    return this.type === 'all';
  }

  public isNameVisible(): boolean {
    return this.isAll() || this.type === 'name';
  }

  public isPlantsVisible(): boolean {
    return this.isAll() || this.type === 'plant';
  }
}
